import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('assignment-of-rights', storeModule.createStoreModule('assignment-of-rights'))
